import { Modal, Input, Button, Form } from 'antd'
import { useState, useMemo, useRef } from 'react'
import { request } from '@utils'
/**
 * 认领学校弹窗
 * 如果判断学校无邮件则要告诉学校无邮箱并展示管理员邮箱
 */
export default (props) => {
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)
  const [isConfirmEmail, setIsConfirmEmail] = useState(!props.email)
  // 重新提交
  const [isResubmit, setIsResubmit] = useState(!props.email)

  const isCorrectName = useMemo(
    () =>
      props && props.email && props.email.toLowerCase() === name.toLowerCase(),
    [name]
  )

  const formRef = useRef(null)

  const onConfirm = () => {
    if (isResubmit) {
      formRef.current.validateFields().then((values) => {
        setLoading(true)
        request('/api/claim/add', {
          method: 'POST',
          data: { school_id: props.id, ...values }
        })
          .then(() => {
            Modal.success({
              title: 'Successfully',
              content:
                'Thank you for your submission. We will notify you of the outcome of the review process via email once it has been completed.'
            })
            props.onCancel()
            setName('')
            setLoading(false)
          })
          .catch(() => {
            setLoading(false)
          })
        // props.onCancel()
        // setLoading(false)
      })
    } else {
      setLoading(true)
      request('/api/school/claim', {
        method: 'POST',
        data: { school_id: props.id }
      })
        .then(() => {
          Modal.success({
            title: 'Successfully',
            content:
              'Your submission has been successful. A verification link has been sent to your email address.'
          })
          props.onCancel()
          setName('')
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }

  const opt = {
    title: 'Claim School',
    open: props.visible,
    footer: isConfirmEmail
      ? [
          <Button onClick={onConfirm} key="1" type="primary" loading={loading}>
            {isResubmit ? 'Submit' : 'Confirm'}
          </Button>
        ]
      : null,
    onCancel() {
      props.onCancel()
    }
  }

  return (
    <Modal {...opt}>
      {isConfirmEmail ? (
        <>
          {isResubmit ? (
            <>
              <div style={{ marginBottom: 20 }}>
                {props.email
                  ? 'please fill out the form below, and our staff will promptly reach out to assist you with the claim process.'
                  : 'Unfortunately, it seems that the provided email address for your current school does not exist, making it impossible for us to complete the claim process. If you are the administrator of the school, please fill out the form below, and our staff will promptly reach out to assist you with the claim process.'}
              </div>
              <Form
                ref={formRef}
                layout="vertical"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                style={{
                  maxWidth: 600,
                  background: '#eee',
                  padding: 12,
                  borderRadius: 3
                }}
                autoComplete="off"
              >
                {/* <Form.Item
                  label="School Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: `Please re-enter the school name`
                    }
                  ]}
                >
                  <Input autoFocus />
                </Form.Item> */}

                <Form.Item
                  label="Adminitrator's Name"
                  name="admin_name"
                  rules={[
                    {
                      required: true,
                      message: `Please input Adminitrator's Name`
                    }
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Administrator's Email"
                  name="admin_email"
                  rules={[
                    {
                      required: true,
                      message: `Please input Administrator's Email!`
                    },
                    {
                      required: true,
                      type: 'email',
                      message: 'Please enter a correct email address!'
                    }
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Phone Number"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: `Please input Phone Number!`
                    },
                    {
                      len: 10
                    }
                  ]}
                >
                  <Input type="number" maxLength={10} addonBefore="+1" />
                </Form.Item>
              </Form>
            </>
          ) : (
            <>
              <div>
                You will claim school [<b>{props.name}</b>], and we will send a
                verification email to your school mailbox [<b>{props.email}</b>
                ]. Please confirm if you wish to claim ownership of this school.
              </div>
              {/* <Input
                autoFocus
                style={{ marginTop: 10 }}
                disabled={!props.email}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={
                  props.email
                    ? 'please input this school name'
                    : 'isabellacai@ymontessori.com'
                }
              ></Input> */}
            </>
          )}
        </>
      ) : props.isClaimed ? (
        <>
          <div>
            This school has already been claimed. If you are interested in
            claiming this school for yourself or your organization, kindly reach
            out to us at{' '}
            <b style={{ background: '#ccc', fontSize: 18, padding: '1px 3px' }}>
              hello@ymontessori.com
            </b>
            . Our team will be more than happy to assist you with any inquiries
            or further steps in the process.
          </div>
        </>
      ) : (
        <>
          <div>
            Please confirm if the email address: <br />
            <b style={{ background: '#ccc', fontSize: 18, padding: '1px 3px' }}>
              {props.email}
            </b>
            <br />
            associated with your school is correct.{' '}
          </div>
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Button
              style={{ width: 150, borderRadius: 10 }}
              type="primary"
              onClick={() => setIsConfirmEmail(true)}
            >
              Correct
            </Button>
          </div>
          <div
            style={{
              textAlign: 'center',
              color: '#999',
              cursor: 'pointer',
              marginTop: 2
            }}
            onClick={() => {
              setIsResubmit(true)
              setIsConfirmEmail(true)
            }}
          >
            This email is incorrect
          </div>
        </>
      )}
    </Modal>
  )
}
